import React, {Fragment, useContext, useEffect, useState} from "react";
import { languageContext } from "../../../config/language";

// styled components
import { PageContainer } from "../../Common/NavTabs/styles";

// components
import NavTabs from "../../Common/NavTabs";
import Orders from "../Tabs/Orders/Orders.container";
import Legacy from "../Tabs/Legacy/Legacy.container";
import OrdersMassive from "../Tabs/retry/Orders.container";
import Budgets from "../Tabs/Budgets/Budgets.container";

// types
import { DateRange } from "../../../types/common";
import {getFeaturesAllowed, FeaturesAllowedDto, getIndicators} from "../../../utils/commonFetchers";

interface Props {
  // filters
  rangeDate: DateRange;
  activeFilters: any;
  filtersChanged: boolean;
  sendFilters: () => void;
  reintentosQuantity:number;
  pendienteDescargaQuantity:number;
  setReintentosQuantity:(param: number) => void;
  setPendienteDescargaQuantity:(param: number) => void;
}

interface Tab {
  page: number;
  name: string;
  entity: string;
  component: any;
}

export default (props: Props) => {
  const { languageContext: lang } = useContext(languageContext);

  const [selectedPage, setSelectedPage] = useState(1);
  const [featurePermissions, setFeaturePermissions] = useState<FeaturesAllowedDto[]>([]);
  const [allowedTabs, setAllowedTabs] = useState<string[]>([]);

  //NO TOCAR LA LA VARIABLE 'feature', NO CAMBIAR SU VALOR NI USARLA EN OTRO LADO
  const _tabs = [
    {
      page: 1,
      name: lang.orders360,
      entity: "orders",
      feature: "orders",
      component: (
        <Orders
          rangeDate={props.rangeDate}
          activeFilters={props.activeFilters}
          sendFilters={props.sendFilters}
          featuresAllowed={allowedTabs}
        />
      ),
    },
    {
      page: 2,
      name: lang.legacy,
      entity: "seller_stats",
      feature: "seller_stats",
      component: (
        <Legacy
          rangeDate={props.rangeDate}
          activeFilters={props.activeFilters}
          sendFilters={props.sendFilters}
          featuresAllowed={allowedTabs}
        />
      ),
    },
    {
      page: 3,
      name: lang.massive,
      entity: "rejected_orders",
      feature: "rejected_orders",
      component: (
        <OrdersMassive
          rangeDate={props.rangeDate}
          activeFilters={props.activeFilters}
          sendFilters={props.sendFilters}
          featuresAllowed={allowedTabs}
        />
      ),
    },
    {
      page: 4,
      name: lang.budgets,
      entity: "budgets",
      feature: "budgets",
      component: (
        <Budgets
          rangeDate={props.rangeDate}
          activeFilters={props.activeFilters}
          sendFilters={props.sendFilters}
          featuresAllowed={allowedTabs}
        />
      ),
    }
  ];

  useEffect(() => {
    getFeaturesAllowed()
        .then(xs => {
          setFeaturePermissions(xs);
          setAllowedTabs(
            xs.filter(x => x.isAllowed)
              .map(x => x.feature)
          );
        });
  }, []);

  const getFilteredTabs = () => _tabs.filter(x => allowedTabs.includes(x.feature));

  return (
      <Fragment>
        <NavTabs
            tabs={getFilteredTabs()}
            selectedPage={selectedPage}
            setSelectedPage={(page: number) => setSelectedPage(() => {
              return page;
            })}
            pendienteDescargaQuantity={props.pendienteDescargaQuantity}
            reintentosQuantity={props.reintentosQuantity}
            setPendienteDescargaQuantity={props.setPendienteDescargaQuantity}
            setReintentosQuantity={props.setReintentosQuantity}
        />
        {
          <PageContainer>
            {getFilteredTabs()
                .map((tab, key) => {
                  return (
                      Boolean(tab.page === selectedPage) && (
                          <Fragment key={key}>{tab.component}</Fragment>
                      )
                  );
                })
            }
          </PageContainer>
        }
      </Fragment>
  );
};
